import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useSetNoteVisibility = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  const t = useI18n();
  return useMutation(
    trpc.notes.updateVisibility.mutationOptions({
      onSuccess: async (data) => {
        queryClient.invalidateQueries({
          queryKey: trpc.notes.getNoteById.queryKey({ id: data.id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.notes.getNotes.queryKey(),
        });
        toast.success(t("noteView.api.visibilityUpdated"));
      },
      onError: (error) => {
        console.error("Failed to update visibility", error);
        toast.error(t("noteView.api.visibilityUpdateFailed"));
      },
    }),
  );
};
